import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { TextField, MenuItem } from '@mui/material';
import { Field } from '../Field';
import { get } from 'lodash';
import React from 'react';
export const FieldDropDown = ({ name, value, options, onChange, dataCy, ...fiedlProps }) => {
    const { values, setFieldValue, setFieldTouched } = useFormikContext();
    const fieldValue = useMemo(() => {
        if (value) {
            return value;
        }
        else if (get(values, name)) {
            return get(values, name);
        }
        else
            return '';
    }, [name, value, values]);
    return (React.createElement(Field, { ...fiedlProps, select: true, fullWidth: true, variant: "outlined", dataCy: dataCy ?? `field-${name}`, name: name, value: fieldValue, component: TextField, onChange: (e) => {
            const value = e.target.value;
            const option = options.find(({ value: optionValue }) => optionValue === value) || null;
            setFieldTouched(name, true, false);
            setFieldValue(name, value, true);
            setTimeout(() => {
                onChange?.(option);
            }, 100);
        } }, options?.map((option) => (React.createElement(MenuItem, { key: option.label, value: option.value, "data-cy-value": option.value }, option.label)))));
};
